function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.index-of.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { ComponentBase } from "./Shared/ComponentBase"; // Helpers

import { CardBuilder } from "./Helpers/CardBuilder";
import { I18N } from "./Shared/I18n";
import { Configuration } from "./Shared/Configuration";
import { QueryStringFilter } from "./Shared/QueryStringFilter";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { AttributeFilter } from "./Shared/AttributeFilter";
import { ReturnContext } from "./Shared/ReturnContextProvider";
import { InvoiceStatus } from "./Shared/Constants"; // Services

import { GroupsApiService } from "./Services/GroupsApiService";
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { CheckoutApiService } from "./Services/CheckoutApiService";
export var MppMyInvoices = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppMyInvoices, _ComponentBase);

  var _super = _createSuper(MppMyInvoices);

  function MppMyInvoices() {
    var _this;

    _classCallCheck(this, MppMyInvoices);

    _this = _super.call(this);
    _this.config = new Configuration();
    _this._appRoot = _this.config.GetAppRoot();
    _this.currData = [];
    _this.userLoggedIn = false;
    return _this;
  }

  _createClass(MppMyInvoices, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log('Attribute changed', newValue);
      var attributesChange = this.loadAttributes();

      if (this._$widgetReady) {
        this.DisplayOptionalDiv();
      }

      if (!!this._$searchButton) {
        if (attributesChange) {
          this._$searchButton.click();
        }
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      var _this$getAttribute;

      this.targetUrl = this.getAttribute("targeturl") || this.getAttribute("target");
      this.hideFreeEventsCheckbox = ((_this$getAttribute = this.getAttribute("hideFreeEventsCheckbox")) === null || _this$getAttribute === void 0 ? void 0 : _this$getAttribute.toLowerCase()) === "true" || false;
      var attributesChanged = false;

      if (!!this._$searchForm) {
        attributesChanged = AttributeFilter.ApplyFilter(this, this._$searchForm);
      }

      return attributesChanged;
    } // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MppMyInvoices.WidgetDetails.tag);
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _mppWidgetsConfigValu,
            _this2 = this;

        var i18n, mppWidgetsConfigValues;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                }

                return _context.abrupt("return");

              case 10:
                this._i18n = i18n; // Load initial values of tag attributes:

                this.loadAttributes();
                _context.next = 14;
                return this.config.GetGlobalConfigurationSettingValues();

              case 14:
                mppWidgetsConfigValues = _context.sent;
                this._invoiceDetailWidgetIdParameterName = (_mppWidgetsConfigValu = mppWidgetsConfigValues.invoiceDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu !== void 0 ? _mppWidgetsConfigValu : "id"; // Root Html

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mppw-form-wrapper" id="myInvoicesWrapper" style="display: none;"><h1>${ i18n.pageTitle }</h1><form class="mppw-form mppw-form-validate" id="searchForm"><input type="hidden" id="invoice" name="invoiceId" class="search-option"/><div class="mppw-form-field mppw-form-field__static-container"><select name="congregationId" class="mppw-form-field__control search-option" id="congregationId" value=""></select> <label class="mppw-form-field__label" for="congregationId">${ i18n.congregationLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><input name="keyword" class="mppw-form-field__control search-option" type="text" id="keywordSearchText"/> <label class="mppw-form-field__label" for="keywordSearchText">${ i18n.keyWordLabel }</label></div><div class="mppw-right"><a class="mppw-btn secondary mppw-btn--small" href="#" id="advancedSearchLink" data-searchmode="0">${ i18n.showAdvancedSearchLabel }</a></div><div id="advancedSearchSection" style="display: none"><div class="mppw-form-field mppw-form-field__static-container"><select name="monthId" class="mppw-form-field__control search-option advanced-option" id="monthId" value=""></select> <label class="mppw-form-field__label" for="monthId">${ i18n.monthLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><select name="invoiceStatusId" class="mppw-form-field__control search-option advanced-option" id="invoiceStatusId" value="0"><option value="0">${ i18n.allInvoicesLabel }</option><option value="1">${ i18n.payBalanceLabel }</option><option value="2">${ i18n.paidInFullLabel }</option></select> <label class="mppw-form-field__label" for="invoiceStatusId">${ i18n.invoiceStatusLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container" id="optionalDiv"><div class="mppw-form-field__control" value=""><label><input name="includeZeroInvoice" value="false" type="checkbox" id="includeZeroInvoice" class="search-option advanced-option"/> <span class="mppw-checkbox"></span>${ i18n.freeEventsLabel }</label></div><label class="mppw-form-field__label">${ i18n.optionalLabel }</label></div></div><div class="mppw-centered"><input type="submit" class="mppw-btn primary" id="searchButton" value="${ i18n.searchButtonText }"/></div></form></div><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="emptyContainer" style="display: none;"></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div id="myGroupsNotLoggedIn" class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div class="resultsContainer mppw-card--grid" id="resultsContainer"></div></div>` ;
                this._checkoutService = new CheckoutApiService();
                this._groupsService = new GroupsApiService();
                this.BindHtmlElements(); // Try logging in user

                this.TryLoginUser();

                this._$loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });

                this._getGroupApiService(i18n);

                this._$searchForm.addEventListener("submit", function (event) {
                  event.preventDefault();

                  if (!!_this2.userLoggedIn && _this2.currData.length > 0) {
                    var invoiceZeroChecked = _this2._$includeZeroInvoice.checked;

                    _this2.BuildFilter(invoiceZeroChecked);
                  }
                });

                this._$advancedSearchLink.addEventListener("click", function (event) {
                  var searchMode = _this2._$advancedSearchLink.getAttribute("data-searchmode");

                  if (searchMode === "0") {
                    _this2._$advancedSearchLink.innerHTML = _this2._i18n.hideAdvancedSearchLabel;
                    _this2._$advancedSearchSection.style.display = "block";

                    _this2._$advancedSearchLink.setAttribute("data-searchmode", "1");
                  } else {
                    _this2._$advancedSearchLink.innerHTML = _this2._i18n.showAdvancedSearchLabel;
                    _this2._$advancedSearchSection.style.display = "none";

                    _this2._$advancedSearchLink.setAttribute("data-searchmode", "0");
                  }

                  _this2._$invoiceStatusId.selectedIndex = "0";
                  _this2._$monthId.selectedIndex = "0";
                  event.preventDefault();
                });

                this._$invoiceStatusId.addEventListener("change", function (event) {
                  //event.preventDefault();
                  _this2.DisplayOptionalDiv();
                });

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "_getGroupApiService",
    value: function _getGroupApiService(i18n) {
      var _this3 = this;

      return this._groupsService.GetConfigurations().then(function (data) {
        DropdownBuilder.LoadDropdown(_this3._$congregationId, data.congregations, i18n.congregationPlaceholderText);
        DropdownBuilder.BuildMonthsList(_this3._$monthId, i18n.monthPlaceHolderText);
        var advancedSearchOpened = false;
        var returnContext = ReturnContext.Get(ReturnContext.Categories.Groups);

        if (!!returnContext && returnContext.Url == window.location.href) {
          advancedSearchOpened = ReturnContext.ApplyFilter(returnContext.FormData, _this3._$searchForm, _this3._$advancedSearchSection);
        } else {
          advancedSearchOpened = QueryStringFilter.ApplyFilter(_this3._$searchForm, _this3._$advancedSearchSection);
        }

        AttributeFilter.ApplyFilter(_this3, _this3._$searchForm, true); //This could be improved since it duplicates code from below:

        if (!!advancedSearchOpened) {
          _this3._$advancedSearchLink.innerHTML = i18n.hideAdvancedSearchLabel;
          _this3._$advancedSearchSection.style.display = "block";

          _this3._$advancedSearchLink.setAttribute("data-searchmode", "1");
        }

        _this3.DisplayOptionalDiv();

        _this3._$searchButton.click();
      })["catch"](function (error) {
        //TODO: Write error to UI
        console.error(error);
      });
    }
  }, {
    key: "TryLoginUser",
    value: function TryLoginUser() {
      var _this4 = this;

      UserService.GetCurrentUser().then(function (userInfo) {
        _this4._$widgetReady = true;

        if (!!userInfo) {
          _this4.userLoggedIn = true;
        }

        _this4._$loginButtonContainer.style.display = "none";
        _this4._$myInvoicesWrapper.style.display = "";

        _this4.GetMyInvoices();
      }, function () {
        _this4._$myInvoicesWrapper.style.display = "none";
        _this4._$loginButtonContainer.style.display = "";
        _this4._$loadingContainer.style.display = "none";
      });
    } // istanbul ignore next

  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      this._$myInvoicesWrapper = this._root.querySelector("#myInvoicesWrapper");
      this._$resultsContainer = this._root.querySelector("#resultsContainer");
      this._$loadingContainer = this._root.querySelector("#loadingContainer");
      this._$emptyContainer = this._root.querySelector("#emptyContainer");
      this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
      this._$loginButton = this._root.querySelector("#loginButton");
      this._$searchForm = this._root.querySelector("#searchForm");
      this._$congregationId = this._root.querySelector("#congregationId");
      this._$keywordSearchText = this._root.querySelector("#keywordSearchText");
      this._$invoiceStatusId = this._root.querySelector("#invoiceStatusId");
      this._$monthId = this._root.querySelector("#monthId");
      this._$searchButton = this._root.querySelector("#searchButton");
      this._$advancedSearchLink = this._root.querySelector("#advancedSearchLink");
      this._$advancedSearchSection = this._root.querySelector("#advancedSearchSection");
      this._$includeZeroInvoice = this._root.querySelector("#includeZeroInvoice");
      this._$optionalDiv = this._root.querySelector("#optionalDiv");
      this.DisplayOptionalDiv();
    }
  }, {
    key: "GetInvoicePayButton",
    value: function GetInvoicePayButton(myInvoiceData) {
      if (!!myInvoiceData) {
        var myInvoiceDetailsButton = '';

        if (myInvoiceData.invoice_Status_ID !== null && myInvoiceData.invoice_Status_ID != 3) {
          if (this.targetUrl !== null && !!this.targetUrl) {
            var idUrlString = this.targetUrl.indexOf("?") > -1 ? "&".concat(this._invoiceDetailWidgetIdParameterName, "=") : "?".concat(this._invoiceDetailWidgetIdParameterName, "=");
            var payBalanceUrl = this.targetUrl + idUrlString;
            myInvoiceDetailsButton = CardBuilder.BuildCloudAppDetailsButton(myInvoiceData.invoice_Guid, payBalanceUrl, this._i18n.payBalanceButtonText);
          }
        }

        return myInvoiceDetailsButton;
      }
    }
  }, {
    key: "DisplayOptionalDiv",
    value: function DisplayOptionalDiv() {
      if (this.hideFreeEventsCheckbox || this._$invoiceStatusId.selectedIndex === 1) {
        this._$includeZeroInvoice.checked = false;
        this._$optionalDiv.style.display = "none";
      } else {
        this._$optionalDiv.style.display = "";
      }
    }
  }, {
    key: "BuildFilter",
    value: function BuildFilter(invoiceZeroChecked) {
      var hereData = this.currData;
      var congregationValue = 0,
          keywordValue = '',
          monthValue = 0,
          invoiceStatusValue = 0;

      if (this._$congregationId.value !== '') {
        congregationValue = Number(this._$congregationId.value);
      }

      if (this._$keywordSearchText.value !== '') {
        keywordValue = this._$keywordSearchText.value;
      }

      if (this._$monthId.value !== '') {
        monthValue = Number(this._$monthId.value);
      }

      if (this._$invoiceStatusId.value !== '') {
        invoiceStatusValue = Number(this._$invoiceStatusId.value);
      }

      var filterOnZeroInvoice = function filterOnZeroInvoice(invoiceZeroChecked, each) {
        if (!!invoiceZeroChecked) {
          return true;
        }

        if (each.invoice_Total > 0) {
          return true;
        }

        return false;
      };

      var filterOnCongregation = function filterOnCongregation(congregationValue, each) {
        if (congregationValue === 0) {
          return true;
        }

        if (each.congregation_ID === congregationValue) {
          return true;
        }

        return false;
      };

      var filterOnKeyWord = function filterOnKeyWord(keywordValue, each) {
        if (keywordValue === '') {
          return true;
        }

        var dtStr = '';

        if (each.invoice_Date !== '') {
          var dt = new Date(each.invoice_Date);
          dtStr = ('0' + (dt.getMonth() + 1)).slice(-2) + "/" + ('0' + dt.getDate()).slice(-2) + "/" + dt.getFullYear();
        }

        var kwReg = new RegExp(keywordValue, "i");

        if (kwReg.test(each.product_Name) || kwReg.test(each.invoice_ID) || kwReg.test(each.invoice_Status) || kwReg.test(each.invoice_Total) || dtStr !== '' && kwReg.test(dtStr) || kwReg.test(each.purchaser_Contact)) {
          return true;
        }

        return false;
      };

      var filterOnMonth = function filterOnMonth(monthValue, each) {
        if (monthValue === 0) {
          return true;
        }

        var d = new Date(each.invoice_Date);
        var month = d.getMonth() + 1;

        if (month === monthValue) {
          return true;
        }

        return false;
      };

      var filterOnInvoiceStatus = function filterOnInvoiceStatus(invoiceFilterOption, each) {
        if (invoiceFilterOption === 0) {
          return true;
        }

        var validStatuses = [];

        switch (invoiceFilterOption) {
          case 0:
            return true;

          case 1:
            validStatuses = [InvoiceStatus.SomePaid, InvoiceStatus.NonePaid];
            break;

          case 2:
            validStatuses = [InvoiceStatus.PaidInFull];
            break;
        }

        return validStatuses.includes(each.invoice_Status_ID);
      };

      hereData = hereData.filter(function (each) {
        return filterOnZeroInvoice(invoiceZeroChecked, each);
      });

      if (congregationValue > 0) {
        hereData = hereData.filter(function (each) {
          return filterOnCongregation(congregationValue, each);
        });
      }

      if (keywordValue !== '') {
        hereData = hereData.filter(function (each) {
          return filterOnKeyWord(keywordValue, each);
        });
      }

      if (monthValue > 0) {
        hereData = hereData.filter(function (each) {
          return filterOnMonth(monthValue, each);
        });
      }

      if (invoiceStatusValue > 0) {
        hereData = hereData.filter(function (each) {
          return filterOnInvoiceStatus(invoiceStatusValue, each);
        });
      }

      this.buildInvoicesResult(hereData);
    }
  }, {
    key: "GetMyInvoices",
    value: function GetMyInvoices() {
      var _this5 = this;

      this.currData = [];
      return this._checkoutService.GetMyInvoices().then(function (data) {
        _this5.currData = data;

        _this5.BuildFilter(false);
      })["catch"](function (error) {
        console.error(error);
        _this5._$loadingContainer.style.display = "none";
      });
    }
  }, {
    key: "buildInvoicesResult",
    value: function buildInvoicesResult(data) {
      this._$emptyContainer.innerHTML = "";
      this._$resultsContainer.innerHTML = "";
      this._$loadingContainer.style.display = "";

      if (data.length <= 0) {
        // No invoices associated to user
        this._$emptyContainer.style.display = "";
        this._$emptyContainer.innerHTML += "<div id=\"myInvoicesEmpty\" class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(this._i18n.noInvoicesFoundMessage, "</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>");
        this._$loadingContainer.style.display = "none";
      } else {
        // Loop through each invoice and build page with cards
        this._$emptyContainer.style.display = "none";
        var resultsContainerHTML = "";

        for (var i = 0; i < data.length; i++) {
          var _data$i = _objectSpread({}, data[i]),
              invoice_ID = _data$i.invoice_ID,
              invoice_Date = _data$i.invoice_Date,
              invoice_Guid = _data$i.invoice_Guid,
              invoice_Status_ID = _data$i.invoice_Status_ID,
              invoice_Status = _data$i.invoice_Status,
              invoice_Total = _data$i.invoice_Total,
              purchaser_Contact = _data$i.purchaser_Contact,
              purchaser_Contact_ID = _data$i.purchaser_Contact_ID,
              product_Name = _data$i.product_Name,
              description = _data$i.description,
              imageUrl = _data$i.imageUrl;

          var invoicePayButton = this.GetInvoicePayButton(data[i]);
          var subtitlesArr = CardBuilder.BuildMyInvoicesSubtitlesArr(invoice_Date, invoice_Total, invoice_Status);
          resultsContainerHTML += CardBuilder.BuildCard(CardBuilder.BuildImage(imageUrl, 'receipt'), CardBuilder.BuildText("Invoice ".concat(invoice_ID), subtitlesArr, "Invoice of ".concat(purchaser_Contact, " for ").concat(product_Name)), invoicePayButton);
        }

        this._$resultsContainer.innerHTML = resultsContainerHTML ? resultsContainerHTML : this._i18n.noInvoicesFoundMessage;
        this._$loadingContainer.style.display = "none";
      }
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "My Invoices",
        tag: "mpp-my-invoices",
        configurationItems: [{
          name: "Target URL",
          attribute: "targeturl",
          description: "URL that takes the authenticated User to the Invoice Details & Payment Widget so they can pay an outstanding invoice. Should be the URL of the webpage containing your Invoice Details & Payment Widget. Must be a fully qualified URL.",
          required: true,
          type: "url"
        }, {
          name: "Congregation",
          attribute: "congregationid",
          description: "Filters the results by a Congregation ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Congregations",
          fkFilter: "",
          fkSingleName: "Congregation"
        }, {
          name: "Key Word",
          attribute: "keyword",
          description: "Filters the result using keywords. Key Word search looks for a match in the Invoice Title, Status, or Product Name, so choose your key word attribute strategically (Default: Empty or NULL).",
          required: false,
          type: "text"
        }, {
          name: "Month",
          attribute: "monthid",
          description: "Filters by a Month. (Default: Empty or NULL).",
          required: false,
          type: "list",
          listValues: [{
            label: "All Months",
            value: ""
          }, {
            label: "January",
            value: 1
          }, {
            label: "February",
            value: 2
          }, {
            label: "March",
            value: 3
          }, {
            label: "April",
            value: 4
          }, {
            label: "May",
            value: 5
          }, {
            label: "June",
            value: 6
          }, {
            label: "July",
            value: 7
          }, {
            label: "August",
            value: 8
          }, {
            label: "September",
            value: 9
          }, {
            label: "October",
            value: 10
          }, {
            label: "November",
            value: 11
          }, {
            label: "December",
            value: 12
          }]
        }, {
          name: "Invoice Status",
          attribute: "invoiceStatusId",
          description: "Filters by Invoice Status. (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Invoice_Statuses",
          fkFilter: "",
          fkSingleName: "Invoice Status"
        }, {
          name: "Hide Free Events Checkbox",
          attribute: "HideFreeEventsCheckbox",
          description: "Determines whether or not the Free Events checkbox is visible to the end users. (Default: Empty or NULL).",
          required: false,
          type: "bool"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["target", "targeturl", "congregationid", "monthid", "invoiceStatusId", "keyword", "hidefreeeventscheckbox"];
    }
  }]);

  return MppMyInvoices;
}(ComponentBase);
MppMyInvoices.registerComponent(MppMyInvoices.WidgetDetails.tag, MppMyInvoices);